'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.games = exports.getGameCategory = exports.getGameCategories = exports.Device = void 0;
var tslib_1 = require("tslib");
var adapter_1 = require("../adapter");
var transport_1 = require("../transport");
var util_1 = require("../util");
var Device;
(function (Device) {
    Device["DESKTOP"] = "Desktop";
    Device["IPAD"] = "iPad";
    Device["IPHONE"] = "iPhone";
    Device["ANDROID"] = "Android Phone";
    Device["WM7"] = "WM7";
    Device["WM8"] = "WM8";
    Device["IPOD"] = "iPod";
    Device["ANDROID_TABLET"] = "Android Tablet";
})(Device = exports.Device || (exports.Device = {}));
var GameDevices = Object.values(Device);
/**
 * Given a game slug and a list of categories. It returns the list of categories
 * which contain the game
 * @param gameSlug the game slug
 * @param categories the list of categoris
 * @returns the list of matched categories
 */
function getGameCategories(gameSlug, categories) {
    var categoriesArray = Array.from(categories.values());
    return categoriesArray.filter(function (category) { return category.games.has(gameSlug); });
}
exports.getGameCategories = getGameCategories;
function getGameCategory(gameSlug, categories, defaultCategories, mobile) {
    var filteredCats = getGameCategories(gameSlug, categories)
        .map(function (category) { return category.slug; })
        .filter(function (cat) { return !defaultCategories.includes(cat); });
    return (filteredCats[0] ||
        (mobile ? defaultCategories[1] : defaultCategories[0]));
}
exports.getGameCategory = getGameCategory;
var Games = /** @class */ (function () {
    function Games() {
        this.production = false;
    }
    /**
     * Setup configuration for games
     */
    Games.prototype.setup = function (options) {
        this.production = options.production;
    };
    /**
     * Fetch and serialize games from the cdn
     *
     * @param [mobile=true]
     * @param [lang='en']
     * @param [country='GB']
     * @param [device]
     * @param [defaultCategories=Array<string>]
     */
    Games.prototype.fetch = function (mobile, lang, country, device, defaultCategories) {
        if (mobile === void 0) { mobile = true; }
        if (lang === void 0) { lang = 'en'; }
        if (country === void 0) { country = 'MT'; }
        if (defaultCategories === void 0) { defaultCategories = []; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, rawCategoriesAndGames, gamesMap, categories, vendors, recommendedGames, addCategories, normalizeCategories, deleteSubCategories, categoryList;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = transport_1.transport.getCDNUrl() + "/games/" + lang + "_" + country + (mobile ? '_m' : '') + (this.production ? '' : '-staging') + ".json";
                        return [4 /*yield*/, adapter_1.adapter.games.fetch(url)];
                    case 1:
                        rawCategoriesAndGames = _a.sent();
                        gamesMap = new Map();
                        categories = new Map();
                        vendors = new Set();
                        recommendedGames = new Set();
                        addCategories = function (catList) {
                            var e_1, _a;
                            var _b;
                            var categoryList;
                            if (_this.isRecommendedGamesIncluded(catList)) {
                                categoryList = catList.categories;
                                catList.recommendedGames.forEach(function (game) {
                                    return recommendedGames.add(game);
                                });
                            }
                            else {
                                categoryList = catList;
                            }
                            try {
                                for (var categoryList_1 = tslib_1.__values(categoryList), categoryList_1_1 = categoryList_1.next(); !categoryList_1_1.done; categoryList_1_1 = categoryList_1.next()) {
                                    var categoryEntry = categoryList_1_1.value;
                                    if (categoryEntry.slug === undefined) {
                                        continue;
                                    }
                                    categories.set(categoryEntry.slug, tslib_1.__assign(tslib_1.__assign({}, categoryEntry), { games: new Set((_b = categoryEntry.games) === null || _b === void 0 ? void 0 : _b.map(function (game) { return game.slug; })), subCategories: new Set() }));
                                    if (categoryEntry.subs) {
                                        addCategories(categoryEntry.subs);
                                    }
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (categoryList_1_1 && !categoryList_1_1.done && (_a = categoryList_1.return)) _a.call(categoryList_1);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        };
                        normalizeCategories = function (catList) {
                            var e_2, _a, e_3, _b, e_4, _c;
                            var categoryList;
                            if (_this.isRecommendedGamesIncluded(catList)) {
                                categoryList = catList.categories;
                            }
                            else {
                                categoryList = catList;
                            }
                            try {
                                // Second get all the games and add them to all the categories they belong to
                                for (var categoryList_2 = tslib_1.__values(categoryList), categoryList_2_1 = categoryList_2.next(); !categoryList_2_1.done; categoryList_2_1 = categoryList_2.next()) {
                                    var categoryEntry = categoryList_2_1.value;
                                    var currCategory = categories.get(categoryEntry.slug);
                                    var games_2 = categoryEntry.games || [];
                                    var subCategories = categoryEntry.subs || [];
                                    try {
                                        // Map the categories
                                        for (var subCategories_1 = (e_3 = void 0, tslib_1.__values(subCategories)), subCategories_1_1 = subCategories_1.next(); !subCategories_1_1.done; subCategories_1_1 = subCategories_1.next()) {
                                            var category = subCategories_1_1.value;
                                            currCategory.subCategories.add(category.slug);
                                        }
                                    }
                                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                    finally {
                                        try {
                                            if (subCategories_1_1 && !subCategories_1_1.done && (_b = subCategories_1.return)) _b.call(subCategories_1);
                                        }
                                        finally { if (e_3) throw e_3.error; }
                                    }
                                    normalizeCategories(subCategories);
                                    try {
                                        // Map the games
                                        for (var games_1 = (e_4 = void 0, tslib_1.__values(games_2)), games_1_1 = games_1.next(); !games_1_1.done; games_1_1 = games_1.next()) {
                                            var game = games_1_1.value;
                                            // TODO: Back end bug causing second category games to not have igcDevices.
                                            var devices = game.igcDevices || '';
                                            // Filter them by device
                                            if (device &&
                                                GameDevices.includes(device) &&
                                                devices.indexOf(device) < 0) {
                                                continue;
                                            }
                                            gamesMap.set(game.slug, tslib_1.__assign(tslib_1.__assign({}, game), { category: getGameCategory(game.slug, categories, defaultCategories, mobile), categories: getGameCategories(game.slug, categories).map(function (cat) { return cat.slug; }) }));
                                            // add vendors
                                            if (game.customVendor && game.customVendor !== '') {
                                                vendors.add(game.customVendor);
                                            }
                                            else {
                                                vendors.add(game.vendor);
                                            }
                                        }
                                    }
                                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                                    finally {
                                        try {
                                            if (games_1_1 && !games_1_1.done && (_c = games_1.return)) _c.call(games_1);
                                        }
                                        finally { if (e_4) throw e_4.error; }
                                    }
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (categoryList_2_1 && !categoryList_2_1.done && (_a = categoryList_2.return)) _a.call(categoryList_2);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                        };
                        deleteSubCategories = function (catList) {
                            var e_5, _a;
                            var categoryList;
                            if (_this.isRecommendedGamesIncluded(catList)) {
                                categoryList = catList.categories;
                            }
                            else {
                                categoryList = catList;
                            }
                            try {
                                for (var categoryList_3 = tslib_1.__values(categoryList), categoryList_3_1 = categoryList_3.next(); !categoryList_3_1.done; categoryList_3_1 = categoryList_3.next()) {
                                    var categoryEntry = categoryList_3_1.value;
                                    if (categoryEntry.subs) {
                                        deleteSubCategories(categoryEntry.subs);
                                    }
                                    // @ts-ignore
                                    delete categories.get(categoryEntry.slug).subs;
                                }
                            }
                            catch (e_5_1) { e_5 = { error: e_5_1 }; }
                            finally {
                                try {
                                    if (categoryList_3_1 && !categoryList_3_1.done && (_a = categoryList_3.return)) _a.call(categoryList_3);
                                }
                                finally { if (e_5) throw e_5.error; }
                            }
                        };
                        addCategories(rawCategoriesAndGames);
                        normalizeCategories(rawCategoriesAndGames);
                        deleteSubCategories(rawCategoriesAndGames);
                        categoryList = Array.from(categories.values()).sort(function (a, b) { return a.position - b.position; });
                        return [2 /*return*/, [
                                gamesMap,
                                categoryList,
                                Array.from(vendors),
                                Array.from(recommendedGames),
                            ]];
                }
            });
        });
    };
    /**
     * Gets the last played game IDs and date.
     *
     * @param numResults The number of results to fetch
     */
    Games.prototype.getLastPlayedGames = function (numResults) {
        return adapter_1.adapter.games.getLastPlayedGames({ numResults: numResults });
    };
    /**
     * Get all recent game winners
     */
    Games.prototype.getRecentWinners = function (args) {
        var params = {
            MinimumWin: args.min,
            Count: args.count,
            maximumWin: args.max,
            device: args.device,
            gameId: args.gameId,
        };
        return adapter_1.adapter.games.getRecentWinners(params);
    };
    /**
     * Get all jackpots for all games filtered by currency
     */
    Games.prototype.jackpots = function (currency) {
        var params = { currency: currency };
        return adapter_1.adapter.games.jackpots(params);
    };
    /**
     * Get the current user's favourite games
     */
    Games.prototype.getFavourites = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.games.getFavourites()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, !result
                                ? []
                                : result.map(function (favourite) {
                                    return util_1.normalize(favourite);
                                })];
                }
            });
        });
    };
    /**
     * Adds a favourite game to the users favourites list
     * @param gameId The game ID to add
     */
    Games.prototype.addFavouriteGame = function (gameId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.games.favourite({
                            gameId: gameId,
                            remove: false,
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, !result
                                ? []
                                : result.map(function (favourite) {
                                    return util_1.normalize(favourite);
                                })];
                }
            });
        });
    };
    /**
     * Removes a favourite game from the users favourites list
     * @param gameId The game ID to remove
     */
    Games.prototype.removeFavouriteGame = function (gameId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.games.favourite({
                            gameId: gameId,
                            remove: true,
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, !result
                                ? []
                                : result.map(function (favourite) {
                                    return util_1.normalize(favourite);
                                })];
                }
            });
        });
    };
    /**
     * Get the URL of the Game to be used in the iFrame or to redirect to
     */
    Games.prototype.launchUrl = function (params) {
        return adapter_1.adapter.games.launchUrl(params);
    };
    /**
     * Get the active game sessions of a user
     * Used in case only one session is allowed at a time
     */
    Games.prototype.checkForActiveSessions = function () {
        var isCorex = transport_1.transport.isCoreX();
        if (isCorex) {
            return adapter_1.adapter.games.checkForCorexActiveSessions();
        }
        else {
            return adapter_1.adapter.games.checkForActiveSessions();
        }
    };
    /**
     * Delete the active game sessions of a user
     * Used in case only one session is allowed at a time
     */
    Games.prototype.deleteActiveSessions = function (params) {
        return adapter_1.adapter.games.deleteActiveSessions(params);
    };
    /**
     * Returns the available list of games by category
     */
    Games.prototype.browser = function (params) {
        return adapter_1.adapter.games.browser(params);
    };
    Games.prototype.getRecommendedGames = function (params) {
        return adapter_1.adapter.games.getRecommendedGames(params);
    };
    Games.prototype.getGREMarketRecommendations = function (params) {
        return adapter_1.adapter.games.getGREMarketRecommendations(params);
    };
    Games.prototype.getDynamicUserRecommendedCategory = function (params) {
        return adapter_1.adapter.games.getDynamicUserRecommendedCategory(params);
    };
    Games.prototype.getGRESimilarGameRecommendations = function (params) {
        return adapter_1.adapter.games.getGRESimilarGameRecommendations(params);
    };
    Games.prototype.isRecommendedGamesIncluded = function (payload) {
        return (payload.categories !==
            undefined);
    };
    /**
     * Get the URL of the Game for CoreX
     */
    Games.prototype.getLaunchGameUrl = function (params) {
        return adapter_1.adapter.games.getLaunchGameUrl(params);
    };
    /**
     * Get the URL of the Game for CoreX for demo play
     */
    Games.prototype.getDemoLaunchGameUrl = function (params) {
        return adapter_1.adapter.games.getDemoLaunchGameUrl(params);
    };
    return Games;
}());
exports.games = new Games();
